import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BarcodeResponse } from './barcodeSlice'

export const barcodeApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT + '/barcode' }),
    reducerPath: 'barcodeApi',
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        count: build.query<BarcodeResponse, void>({
            query: () => `/count`,
            transformResponse: (response: BarcodeResponse) => {
                return response
            },
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCountQuery } = barcodeApi
